var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoint3Icon12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95.969,
    height: 96.087,
    viewBox: "0 0 95.969 96.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_69",
    "data-name": "\\u9577\\u65B9\\u5F62 69",
    width: 95.969,
    height: 96.087,
    fill: "#5f7cae"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_33",
    "data-name": "\\u9577\\u65B9\\u5F62 33",
    width: 29.159,
    height: 8,
    fill: "#5f7cae"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "point3icon1-2",
    transform: "translate(-1650.015 -3130.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_61",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_58",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 58",
    transform: "translate(1650.015 3130.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_57",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 57",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_81",
    "data-name": "\\u30D1\\u30B9 81",
    d: "M95.969,55.724v3.164H83.806V68.2a18.342,18.342,0,0,1,1.87.009,4.691,4.691,0,0,1,4.188,4.752,4.562,4.562,0,0,1-4.249,4.478q-6.579.16-13.165,0a4.561,4.561,0,0,1-4.268-4.652,4.7,4.7,0,0,1,4.164-4.579c.573-.062,1.157-.009,1.883-.009V59.019H71.6c-1.552,2.831-3.984,3.841-7.292,2.865a3.036,3.036,0,0,1-2.322-3.175c0-1.926,0-3.853,0-5.9h-3.1c0,3,0,5.955,0,8.907,0,4.939-1.126,6.179-6.2,6.586v2.05c0,5.875.014,11.75,0,17.625-.015,4.836-3.3,8.094-8.177,8.1q-15.007.019-30.012,0c-5.089,0-8.275-3.237-8.282-8.385q-.012-8.715,0-17.431V68.257c-.665-.029-1.164-.043-1.661-.074A4.576,4.576,0,0,1,.027,63.566q-.054-18.593,0-37.186A4.582,4.582,0,0,1,4.677,21.7c.441-.024.882-.04,1.529-.069,0-4.242,0-8.421,0-12.6C6.208,2.968,9.163,0,15.2,0Q29.726,0,44.247,0c5.242,0,8.426,3.189,8.434,8.428.007,4.374,0,8.748,0,13.183a20.059,20.059,0,0,1,2.472.172,4.745,4.745,0,0,1,3.72,4.966c.016,5.475.005,10.949.005,16.531h3.1c0-1.526,0-3.107,0-4.688,0-3.657.859-4.5,4.579-4.5,3.35,0,3.851.307,4.893,3.087H95.919v3.087H71.372V55.724ZM49.56,7.523a4.542,4.542,0,0,0-4.532-4.4q-15.573-.075-31.147,0A4.565,4.565,0,0,0,9.317,7.693c-.06,1.475-.087,77.371.034,81.034a4.446,4.446,0,0,0,4.48,4.23q15.575.074,31.151.006A4.409,4.409,0,0,0,49.5,88.991c.17-3.776.147-79.934.06-81.469M6.1,64.983v-40.1c-2.642-.146-2.989.151-2.99,2.572q-.009,17.5,0,34.991c0,2.407.369,2.716,2.99,2.536m46.7-40.078V65c2.644.142,2.987-.153,2.989-2.579q.009-17.495,0-34.99c0-2.4-.376-2.716-2.988-2.528M78.957,71.288a49.32,49.32,0,0,0-5.584.069c-.736.084-1.384.943-2.071,1.449.667.527,1.317,1.483,2,1.51,3.786.149,7.584.148,11.37,0,.706-.027,1.379-.943,2.067-1.449-.667-.527-1.292-1.429-2.009-1.509a52.1,52.1,0,0,0-5.776-.073M80.479,59H77.6v9.036h2.881ZM58.967,49.489h2.893v-2.86H58.967Zm9.123,6.429H65.223V58.8H68.09Zm-2.918-3.337h2.879V49.668H65.172Zm2.879-9.044H65.173V46.4h2.878Zm-2.884-3.371h2.867V37.287H65.167Z",
    transform: "translate(0 0)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_82",
    "data-name": "\\u30D1\\u30B9 82",
    d: "M192.08,116.434a4.647,4.647,0,1,1,4.414,4.916,4.7,4.7,0,0,1-4.414-4.916m4.646-1.859c-.7.934-1.516,1.554-1.433,2.014.11.613.915,1.1,1.421,1.643.51-.538,1.319-1.021,1.433-1.633.086-.459-.722-1.085-1.42-2.024",
    transform: "translate(-117.698 -68.666)",
    fill: "#5f7cae"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u6955\\u5186\\u5F62_6",
    "data-name": "\\u6955\\u5186\\u5F62 6",
    transform: "translate(1672 3146)",
    fill: "none",
    stroke: "#62728d",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u6955\\u5186\\u5F62_7",
    "data-name": "\\u6955\\u5186\\u5F62 7",
    transform: "translate(1662 3149)",
    fill: "none",
    stroke: "#62728d",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u6955\\u5186\\u5F62_8",
    "data-name": "\\u6955\\u5186\\u5F62 8",
    transform: "translate(1689 3149)",
    fill: "none",
    stroke: "#62728d",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 2.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_60",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 60",
    transform: "translate(1692 3209.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_7",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 7",
    transform: "translate(-28 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_39",
    "data-name": "\\u30D1\\u30B9 39",
    d: "M19.205,5.3l.265-.7.481-1.36.321-.963c.033-.1.065-.207.1-.31q.035-.117.113-.383c.242.005.436.008.584.008s.338,0,.588-.013.46-.012.632-.012a2.2,2.2,0,0,1,.536.046.711.711,0,0,1,.279.146A.612.612,0,0,1,23.267,2a.756.756,0,0,1,.05.3,1.322,1.322,0,0,1-.057.347,1.745,1.745,0,0,1-.381.666,1.711,1.711,0,0,1-.642.452,2.068,2.068,0,0,1-.779.149,1.949,1.949,0,0,1-.336-.032c.01-.084.02-.208.029-.373s.013-.287.011-.367a1.189,1.189,0,0,0,.247.025.74.74,0,0,0,.456-.132.62.62,0,0,0,.234-.322.412.412,0,0,0,.019-.164.183.183,0,0,0-.062-.118.258.258,0,0,0-.128-.06,1.045,1.045,0,0,0-.179-.014c-.066,0-.136,0-.209.005l-.237.016Q21.11,2.9,20.9,3.543q-.388,1.169-.458,1.4l-.107.353-.549-.005-.578.005",
    transform: "translate(-9.42 -0.752)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_40",
    "data-name": "\\u30D1\\u30B9 40",
    d: "M26.1,5.3q.2-.478.343-.862t.321-.89q.175-.505.355-1.067t.28-.893c.229.005.415.008.557.008s.328,0,.543-.013.423-.012.624-.012a6.224,6.224,0,0,1,.623.027,1.282,1.282,0,0,1,.353.079.739.739,0,0,1,.243.145.58.58,0,0,1,.136.192.627.627,0,0,1,.045.249,1.056,1.056,0,0,1-.049.306,1.516,1.516,0,0,1-.15.341,1.5,1.5,0,0,1-.239.3,1.53,1.53,0,0,1-.327.242,3.172,3.172,0,0,1-.493.208l.04.346q.017.144.041.293l.131.8c.006.034.015.1.027.2q-.454-.005-.612-.005-.2,0-.655.005,0-.142,0-.525c0-.107,0-.19-.006-.247-.005-.129-.017-.309-.033-.541l-.053-.77a1.49,1.49,0,0,0,.285.027,1.236,1.236,0,0,0,.385-.06.743.743,0,0,0,.3-.185.648.648,0,0,0,.164-.264.3.3,0,0,0,0-.205.251.251,0,0,0-.161-.132,1.369,1.369,0,0,0-.409-.043c-.065,0-.132,0-.2,0l-.244.007q-.2.557-.472,1.359T27.281,5.3l-.6-.005q-.161,0-.581.005",
    transform: "translate(-12.715 -0.752)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_41",
    "data-name": "\\u30D1\\u30B9 41",
    d: "M33.74,5.315q.818-2.183,1.173-3.361l.1-.351q.482.005.646.005l.6-.005q-.235.612-.43,1.158-.269.761-.485,1.424t-.357,1.13l-.565-.005q-.166,0-.682.005",
    transform: "translate(-16.366 -0.766)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_42",
    "data-name": "\\u30D1\\u30B9 42",
    d: "M37.308,5.315l.234-.549.744-1.907L38.751,1.6q.509.005.8.005.242,0,.74-.005c-.023.156-.038.274-.046.355s-.015.238-.02.473-.014.438-.027.609-.041.465-.087.88q.251-.427.443-.734t.46-.7q.268-.392.344-.513c.051-.081.125-.2.222-.371q.413.005.812.005.271,0,.754-.005-.329.916-.544,1.575-.424,1.289-.57,1.773c-.02.067-.055.188-.1.364-.243,0-.412-.005-.511-.005q-.213,0-.525.005.1-.244.408-1.165t.388-1.176q.033-.111.088-.31l-.7,1.107-.987,1.545q-.358-.005-.494-.005c-.114,0-.29,0-.527.005l.11-1.5.041-.8q0-.046.009-.114c0-.045.014-.125.028-.239l-.3.753-.558,1.544-.113.348-.486-.005c-.1,0-.263,0-.5.005",
    transform: "translate(-18.072 -0.766)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_43",
    "data-name": "\\u30D1\\u30B9 43",
    d: "M47.422,5.315q.281-.7.455-1.175t.443-1.258q.269-.785.346-1.04l.069-.239q.652.005,1.579.005.855,0,1.509-.005l-.032.089c-.008.022-.037.1-.085.236l-.106.3c-.022.063-.044.127-.064.192q-.527-.021-.89-.021h-.538q-.14,0-.44.013l-.222.625q.324.008.759.008.154,0,.831-.019-.133.348-.3.83-.477-.005-.734-.006-.381,0-.86.019l-.232.66h.318q.141,0,.586-.008l.577-.014q.128,0,.432-.022-.155.4-.306.832-.673-.005-1.479-.005l-1.218,0Z",
    transform: "translate(-22.906 -0.766)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_44",
    "data-name": "\\u30D1\\u30B9 44",
    d: "M17.334,11.652l.141-.33.448-1.146.279-.756q.306,0,.482,0l.445,0c-.014.094-.023.165-.028.214s-.009.144-.012.285-.008.264-.016.366-.025.279-.053.529q.151-.257.267-.442t.277-.42q.161-.236.207-.309c.031-.049.075-.123.133-.223q.249,0,.489,0,.163,0,.454,0-.2.551-.327.947-.255.775-.343,1.067-.018.06-.063.219l-.307,0-.316,0q.058-.147.245-.7t.233-.707c.014-.044.031-.107.053-.186l-.419.666-.594.929-.3,0-.317,0,.066-.9.024-.479c0-.019,0-.042.006-.069s.008-.075.017-.144l-.179.453-.335.929-.068.209-.292,0-.3,0",
    transform: "translate(-8.525 -4.502)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_45",
    "data-name": "\\u30D1\\u30B9 45",
    d: "M23.041,11.652q.169-.422.274-.706t.266-.757q.161-.471.207-.625l.042-.144q.392,0,.95,0,.514,0,.908,0l-.02.054c0,.013-.022.061-.051.142l-.064.178c-.013.038-.027.077-.038.116C25.3,9.9,25.126,9.9,24.98,9.9h-.324c-.056,0-.145,0-.265.007l-.134.376c.131,0,.282.005.457.005.062,0,.228,0,.5-.011-.054.139-.114.306-.182.5l-.441,0c-.153,0-.326,0-.518.011l-.14.4h.192l.352,0,.347-.008c.052,0,.139-.005.261-.013q-.092.242-.184.5-.406,0-.889,0l-.733,0Z",
    transform: "translate(-11.253 -4.502)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_46",
    "data-name": "\\u30D1\\u30B9 46",
    d: "M40.061,11.652q.169-.422.274-.706t.267-.757q.161-.471.207-.625l.042-.144q.392,0,.95,0c.343,0,.645,0,.908,0l-.02.054-.051.142-.063.178c-.014.038-.027.077-.039.116Q42.218,9.895,42,9.9h-.324c-.055,0-.144,0-.264.007l-.134.376q.195.005.456.005c.062,0,.229,0,.5-.011-.053.139-.113.306-.182.5l-.442,0c-.153,0-.326,0-.517.011l-.139.4h.192l.352,0,.346-.008c.052,0,.139-.005.26-.013q-.092.242-.184.5-.406,0-.89,0l-.733,0Z",
    transform: "translate(-19.387 -4.502)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_47",
    "data-name": "\\u30D1\\u30B9 47",
    d: "M48.09,11.652q.169-.422.274-.706t.266-.757q.161-.471.208-.625l.042-.144q.392,0,.95,0,.514,0,.908,0l-.02.054-.051.142-.064.178c-.014.038-.027.077-.038.116q-.318-.013-.536-.013h-.324c-.056,0-.144,0-.264.007l-.134.376q.195.005.456.005c.062,0,.229,0,.5-.011q-.08.209-.182.5l-.442,0c-.153,0-.326,0-.517.011l-.14.4h.192l.352,0,.347-.008c.051,0,.138-.005.26-.013q-.092.242-.184.5-.406,0-.89,0l-.733,0Z",
    transform: "translate(-23.225 -4.502)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_48",
    "data-name": "\\u30D1\\u30B9 48",
    d: "M31.207,11.652q.169-.422.274-.706t.266-.757q.161-.471.208-.625L32,9.419q.392,0,.949,0,.514,0,.908,0l-.02.054-.051.142-.064.178c-.014.038-.027.077-.038.116q-.318-.013-.536-.013h-.324c-.056,0-.144,0-.264.007l-.134.376q.195.005.456.005c.062,0,.229,0,.5-.011q-.08.209-.182.5l-.442,0c-.153,0-.326,0-.517.011l-.14.4h.192l.352,0,.347-.008c.051,0,.138-.005.26-.013q-.092.242-.184.5-.406,0-.89,0l-.733,0Z",
    transform: "translate(-15.156 -4.502)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_49",
    "data-name": "\\u30D1\\u30B9 49",
    d: "M28.109,11.69q.339-.8.661-1.768l-.711.021.066-.183c.036-.1.073-.205.112-.322q.468,0,1.09,0h.8l.215,0-.061.162c-.032.087-.057.158-.077.215s-.034.1-.043.128q-.346-.021-.575-.021h-.115q-.119.292-.21.539c-.088.236-.17.466-.248.688s-.137.4-.181.54l-.347,0-.378,0",
    transform: "translate(-13.651 -4.511)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_50",
    "data-name": "\\u30D1\\u30B9 50",
    d: "M46.144,11.586c-.07.192-.137.378-.2.561q-.116.334-.181.54l-.347,0-.378,0q.222-.526.436-1.121c.031-.085.686-.022.67.02",
    transform: "translate(-21.766 -5.508)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_51",
    "data-name": "\\u30D1\\u30B9 51",
    d: "M35.319,11.688c.081-.193.152-.365.214-.52s.128-.333.2-.536.148-.418.223-.644.135-.406.177-.539q.2.005.329.005t.322-.007c.127-.005.25-.007.37-.007a3.61,3.61,0,0,1,.368.016.755.755,0,0,1,.209.048.435.435,0,0,1,.142.088.325.325,0,0,1,.078.115.372.372,0,0,1,.023.15.647.647,0,0,1-.032.185.966.966,0,0,1-.093.206.93.93,0,0,1-.341.327,1.871,1.871,0,0,1-.294.125l.019.208c.006.058.013.117.021.178l.068.48c0,.021.008.062.014.123l-.363,0-.388,0c0-.057,0-.162,0-.316,0-.064,0-.114,0-.149q0-.117-.014-.326l-.022-.464a.948.948,0,0,0,.168.015.713.713,0,0,0,.227-.036.444.444,0,0,0,.182-.112.409.409,0,0,0,.1-.16.185.185,0,0,0,0-.124.144.144,0,0,0-.092-.08A.776.776,0,0,0,36.9,9.91l-.119,0-.143,0q-.128.337-.3.821t-.322.95l-.356,0-.344,0",
    transform: "translate(-17.121 -4.511)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_52",
    "data-name": "\\u30D1\\u30B9 52",
    d: "M45.283,9.438l.274,1.329h.627L47.39,9.438h-.663l-.746.893L45.8,9.437s-.533.011-.522,0",
    transform: "translate(-21.883 -4.51)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_53",
    "data-name": "\\u30D1\\u30B9 53",
    d: "M2.014,3.612.974,2.572A3.785,3.785,0,0,0,.045,4.794H1.508a2.423,2.423,0,0,1,.505-1.182",
    transform: "translate(-0.022 -1.229)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_54",
    "data-name": "\\u30D1\\u30B9 54",
    d: "M4.892,1.463V0A4.122,4.122,0,0,0,4.4.065,3.8,3.8,0,0,0,2.672.9L3.714,1.946a2.436,2.436,0,0,1,1.178-.482",
    transform: "translate(-1.277 0)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_55",
    "data-name": "\\u30D1\\u30B9 55",
    d: "M6.35,8.021a2.45,2.45,0,0,1-4.865,0H0c-.009.573,0,1.147,0,1.721,0,1.182,0,.909,0,2.091H1.465c0-.3,0-.484,0-1.042a3.924,3.924,0,0,0,6.36-2.771Z",
    transform: "translate(0 -3.834)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_56",
    "data-name": "\\u30D1\\u30B9 56",
    d: "M6.374,7.422a.68.68,0,0,0,.056.193.752.752,0,0,0,.105.17.752.752,0,0,1-.105-.17.68.68,0,0,1-.056-.193",
    transform: "translate(-3.046 -3.547)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_57",
    "data-name": "\\u30D1\\u30B9 57",
    d: "M10.9,3.521a.235.235,0,0,1,.059-.013.24.24,0,0,0-.059.013",
    transform: "translate(-5.21 -1.677)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_58",
    "data-name": "\\u30D1\\u30B9 58",
    d: "M10.689,3.595a.57.57,0,0,1,.085-.047.57.57,0,0,0-.085.047",
    transform: "translate(-5.109 -1.696)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_59",
    "data-name": "\\u30D1\\u30B9 59",
    d: "M11.058,3.513a.2.2,0,0,1,.127.054.2.2,0,0,0-.127-.054",
    transform: "translate(-5.285 -1.679)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_60",
    "data-name": "\\u30D1\\u30B9 60",
    d: "M11.793,3.695l-.181.268a2.452,2.452,0,0,1,.279.841h1.48a3.806,3.806,0,0,0-.066-.435A4.052,4.052,0,0,0,12.438,2.6l-.518.518a.7.7,0,0,1-.127.582",
    transform: "translate(-5.55 -1.24)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_61",
    "data-name": "\\u30D1\\u30B9 61",
    d: "M9.225,1.547a.75.75,0,0,1,.417-.141.608.608,0,0,1,.171.025l.515-.515A3.874,3.874,0,0,0,8.118,0V1.469a2.438,2.438,0,0,1,.824.265l.283-.187",
    transform: "translate(-3.88 -0.002)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_62",
    "data-name": "\\u30D1\\u30B9 62",
    d: "M11.3,3.616h0a.179.179,0,0,1,.065.141.179.179,0,0,0-.065-.141",
    transform: "translate(-5.401 -1.728)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_63",
    "data-name": "\\u30D1\\u30B9 63",
    d: "M10.851,3.541c.009,0,.018,0,.027-.008a.256.256,0,0,0-.027.008",
    transform: "translate(-5.186 -1.689)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_64",
    "data-name": "\\u30D1\\u30B9 64",
    d: "M11.025,3.5l-.011,0a.156.156,0,0,1,.022,0s-.007,0-.011,0",
    transform: "translate(-5.264 -1.674)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_65",
    "data-name": "\\u30D1\\u30B9 65",
    d: "M8.94,3.564a.2.2,0,0,0-.127-.054.155.155,0,0,0-.022,0,.24.24,0,0,0-.059.013c-.009,0-.018,0-.027.008a.57.57,0,0,0-.085.047c-.437.291-.88.573-1.313.871a8.284,8.284,0,0,0-.748.573.594.594,0,0,0-.192.532.712.712,0,0,0,.056.193.755.755,0,0,0,.105.171.653.653,0,0,0,.495.229.72.72,0,0,0,.633-.379c.432-.619.852-1.246,1.275-1.872a.361.361,0,0,0,.073-.188.179.179,0,0,0-.065-.141",
    transform: "translate(-3.041 -1.677)",
    fill: "#5f7cae"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint3Icon12);
export default __webpack_public_path__ + "static/media/point3icon1-2.7bafc2ac1e9cb0d26d797afdfee445e8.svg";
export { ForwardRef as ReactComponent };